export default "__VITE_ASSET__BoEGGr1P__"